// Responsive utilities for Meeting components
// Re-export commonly used functions from styleUtils for backward compatibility
export { 
  getResponsivePadding as getResponsiveSpacing,
  calculateFontSize as calculateDisplayNameFontSize,
  calculateIconPadding,
  calculateButtonPadding,
  calculatePosition as calculateOverlayPosition
} from './styleUtils';


export const calculatePresenterSidebarWidth = (baseWidth, isVeryLargeScreen, isUltraLargeScreen) => {
  if (isUltraLargeScreen) {
    return Math.round(baseWidth * 2);
  } else if (isVeryLargeScreen) {
    return Math.round(baseWidth * 1.5);
  }
  return baseWidth;
};
